const BackImageModel = require("@/appModel/BackImage/BackImageModel")
const InspectPlaceModel = require("@/appModel/InspectPlace/InspectPlaceModel")
const InspectResultModel = require("@/appModel/InspectResult/InspectResultModel")
const InspectMasterModel = require("@/appModel/InspectMaster/InspectMasterModel")
const UserModel = require("@/appModel/users/UserModel")
const DateUtil = require("@/appUtils/DateUtil")
const { default: Condition } = require("yup/lib/Condition")

class InspectPlaceListViewModel {

  constructor(tenantId, projectId, nodeId) {
    this.tenantId = tenantId
    this.projectId = projectId
    this.nodeId = nodeId
    this.inspectMasterList = []
    this.inspectMasterNameById = {}
    this.iconSettingList = []
    this.list = []
    this.filterList = []
    this.additionalFilterList = []
    this.searchCondition = {
      createUser: "",
      createDate: "",
      updateUser: "",
      updateDate: "",
      inspectMasterId: "",
      iconId: ""
    }
    this.userDictionary = {}
    this.addedSearchConditions= {
      inspectMasterId: "",
      inspectSettingItemId: "",
      joinId: "",
      name: "",
      itemType:"",
      value:"",
      dateValues:[]
    }
  }
  async init() {

    // 検査マスタを取得
    await this.getRelatedInspectMaster()

    await this.getInspectPlaceList()
    console.log(`InspectPlaceListViewModel ${this.list.length}件`)
    await this.setFilter()
    await this.setAdditionalFilter()
    await this.getInspectResultList()

  }
  /**
     * 検索条件の内容でフィルタする
     */
  async setFilter(searchCondition = null) {

    // フィルタ前データを取得
    this.filterList = [].concat(this.list)

    if (!searchCondition) {
      return
    }
    console.log(`InspectPlaceListViewModel setFilter ${JSON.stringify(searchCondition)}`)

    this.searchCondition = searchCondition
    // 検査マスタ
    if (this.searchCondition.inspectMasterId) {
      this.filterList = this.filterList.filter(function(item) {
        return item.inspectPlace.inspectMasterId == this.searchCondition.inspectMasterId
      }.bind(this))
    }
    // アイコンID
    if (this.searchCondition.iconId) {
      // 0:マスタID 1:アイコンID
      let iconIdList = this.searchCondition.iconId.split("-")
      let iconId = this.searchCondition.iconId
      let masterId = ""
      // ２要素あればマスタとID
      if (iconIdList.length > 1) {
        masterId = iconIdList[0]
        iconId = iconIdList[1]
      }
      this.filterList = this.filterList.filter(function(item) {
        return item.inspectPlace.iconId == iconId && (!masterId || item.inspectPlace.inspectMasterId == masterId)
      }.bind(this))
    }
    // 作成日の検索
    if (this.searchCondition.createDate) {
      const createDate = DateUtil.dateStringDate(this.searchCondition.createDate)
      this.filterList = this.filterList.filter(function(item) {
        let dbCreateDate = DateUtil.dateStringDate(item.createdAt)
        return dbCreateDate.indexOf(createDate) >= 0
      }.bind(this))
    }

    // 作成者名の検索
    if (this.searchCondition.createUser) {
      this.filterList = this.filterList.filter(function(item) {
        let userName = this.userDictionary[item.createdUser]
        if (userName) {
          return userName.indexOf(this.searchCondition.createUser) >= 0
        } else {
          return false
        }

      }.bind(this))
    }
    // 更新日の検索
    if (this.searchCondition.updateDate) {
      const updateDate = DateUtil.dateStringDate(this.searchCondition.updateDate)
      this.filterList = this.filterList.filter(function(item) {
        let dbUpdateDate = DateUtil.dateStringDate(item.updatedAt)
        return dbUpdateDate.indexOf(updateDate) >= 0

      }.bind(this))
    }

    // 更新者名の検索
    if (this.searchCondition.updateUser) {
      this.filterList = this.filterList.filter(function(item) {
        let userName = this.userDictionary[item.updatedUser]
        if (userName) {
          return userName.indexOf(this.searchCondition.updateUser) >= 0
        } else {
          return false
        }

      }.bind(this))
    }

  }
  /**
   * 追加検索
   * @param {*} inspectPlaces
   * @param {*} addedSearchConditions
   */
  async setAdditionalFilter(searchCondition, addedSearchConditions) {
    if (!addedSearchConditions) {
      return;
    }
    // 検査結果リストを取得
    let resultList = await this.getInspectResultList();
    // 追加検索条件
    this.addedSearchConditions = addedSearchConditions;
    // 既存の検査結果(検査箇所)
    await this.setFilter(searchCondition);

    // 既存検索結果のplaceIdを取り出す
    const placeIds = this.filterList.map(item => item.inspectPlace.placeId);

    // 既存検索結果のplaceIdが含まれる物を取り出す
    const filteredResultList = [];
    resultList.forEach(item => {
      placeIds.forEach(placeId => {
        if (item.sk.includes(placeId)) {
          filteredResultList.push(item);
        }
      });
    });

    // 既存検索結果に検査結果のInspectResultSetオブジェクトを結合させる
    this.additionalFilterList = await this.addInspectResultSet(
      this.filterList,
      resultList
    );

    this.addedSearchConditions.forEach(condition => {
      // 検索条件のタイプ
      const itemType = condition.itemType;
      // 検索条件の値(テキスト型・リスト型)
      const conditionValue = condition.value;
      // 検索条件の値(日付型)
      const conditionDateValue = condition.dateValues;

      // 検索条件と結合リストが一致するリストを取得する
      const nameFilteredAdditionalList = [];
      this.additionalFilterList.forEach(item => {
        let filteredInspectList = [];
        this.addedSearchConditions.forEach(condition => {
          // 結合リストのフォームIDが検索条件のフォームIDと一致するか確認
          if (item.inspectPlace.inspectMasterId === condition.inspectMasterId) {
            // 一致する検査項目をフィルタリング
            filteredInspectList = item.inspectResult.inspectList.filter(
              inspectItem => {
                let foundMatch = false;
                this.addedSearchConditions.forEach(condition => {
                  // 結合リストの項目定義IDが追加の検索条件の項目定義IDと一致するか確認
                  if (inspectItem.itemId === condition.inspectSettingItemId) {
                    foundMatch = true;
                  }
                });
                return foundMatch;
              }
            );
          }
        });
        // フィルタリングされた項目の数が追加の検索条件の数と一致しない場合処理終了
        if (filteredInspectList.length !== this.addedSearchConditions.length) {
          this.additionalFilterList = [];
          return;
        }
        // 追加検索条件順に並び変える
        filteredInspectList = this.addedSearchConditions.map(condition =>
          filteredInspectList.find(
            inspectItem => inspectItem.name === condition.name
          )
        );
        // console.log(`☆検索条件：${JSON.stringify(this.addedSearchConditions)}`)
        if (filteredInspectList.length > 0) {
          const newItem = {
            ...item,
            inspectResult: {
              ...item.inspectResult,
              inspectList: filteredInspectList
            }
          };
          // 重複チェックのために既存のアイテムと比較
          let exists = false;
          nameFilteredAdditionalList.forEach(existingItem => {
            if (JSON.stringify(existingItem) === JSON.stringify(newItem)) {
              // 重複があればtrueに
              exists = true;
            }
          });
          // 重複がなければ追加
          if (!exists) {
            nameFilteredAdditionalList.push(newItem);
          }
        }
      });

      const filterList = [];
      nameFilteredAdditionalList.forEach(item => {
        let matchesAllConditions = true;
        item.inspectResult.inspectList.forEach(inspectItem => {
          let matchesCondition = false;
          // 名前が一致しない場合はスキップ
          if (inspectItem.name !== condition.name) {
            return;
          }
          switch (itemType) {
            // テキスト型の検索
            case "1":
              if (inspectItem.itemType === itemType &&
                // 両方が空の場合
                ((conditionValue === "" && inspectItem.value === "") ||
                  (conditionValue !== "" &&
                    inspectItem.value.indexOf(conditionValue) >= 0))
              ) {
                matchesCondition = true;
              }
              break;
            // 日付型の検索
            case "3":
            if (
              conditionDateValue &&
              conditionDateValue.length > 1 &&
              inspectItem.value
            ) {
              // 開始日
              const fromDate = conditionDateValue[0];
              // 終了日
              const toDate = conditionDateValue[1];
              const dbInspectDate = DateUtil.dateStringDate(inspectItem.value);

              if (
                DateUtil.isWithinPeriodTarget(fromDate, toDate, dbInspectDate)
              ) {
                matchesCondition = true;
              }
            } else {
              let effectiveConditionValue = conditionDateValue;
              let inspectValue = inspectItem.value;
              // 空に設定　※空配列の場合も
              if (!effectiveConditionValue || effectiveConditionValue.length === 0) {
                effectiveConditionValue = "";
              }
              if (!inspectItem.value) {
                inspectValue = "";
              }
              // 両方が空の場合
              if (effectiveConditionValue === "" && inspectValue === "") {
                matchesCondition = true;
              }
            }
              break;
            // リスト型の検索
            case "4":
              if (inspectItem.valueId === conditionValue) {
                matchesCondition = true;
              }
              break;
          }
          if (!matchesCondition) {
            matchesAllConditions = false;
          }
        });
        if (matchesAllConditions) {
          filterList.push(item);
        }
        this.additionalFilterList = filterList;
      });
    });
    return this.additionalFilterList;
  }
  /**
   * 関連する検査マスタを取得
   */
  async getRelatedInspectMaster() {

    const sk = BackImageModel.createSk(this.projectId, this.nodeId)
    const backImageData = await BackImageModel.getBackImage({sk: sk}, this.tenantId)
    this.inspectMasterList = []
    for (let i = 0; i < backImageData.backImage.inspectMasterList.length;i++) {
      const inspectMasterId = backImageData.backImage.inspectMasterList[i]
      let master = await InspectMasterModel.getInspectMaster(InspectMasterModel.createSk(inspectMasterId), this.tenantId)
      this.inspectMasterList.push(master)
      this.inspectMasterNameById[master.inspectMaster.id] = master.inspectMaster.name
      let iconSetList = []
      // アイコンIDが重複する場合を想定し、フォームIDとセットで配列を構成する
      master.inspectMaster.iconSetting.forEach(icon => {
        iconSetList.push({masterId: inspectMasterId, iconSetting: icon})
      })
      // this.iconSettingList = this.iconSettingList.concat(master.inspectMaster.iconSetting)
      this.iconSettingList = this.iconSettingList.concat(iconSetList)
    }


  }
  /**
   * 検査箇所リストを取得
   */
  async getInspectPlaceList() {
    this.list = await InspectPlaceModel.getInspectPlaceList(this.projectId, this.nodeId, this.tenantId)
    await this.getUserList()
  }
  /**
   * ユーザ一覧を取得する
  */
 async getUserList() {
   // ユーザーID→名前参照用のコレクション
   this.userDictionary = {}
   let userList = await UserModel.getUserList(this.tenantId)
   userList.forEach(function(item) {
     // 削除ユーザは省く
     if (!item.user.deleted) {
        this.userDictionary[item.user.userId] = item.user.name
      }
    }.bind(this))
  }
  /**
   * 検索結果リストを取得する
   * @returns 検索結果リスト
   */
  async getInspectResultList(){

    // placeIdに空文字を指定し全件取得
    let placeId = "";

    const results = await InspectResultModel.getInspectResultList(
      this.projectId,
      this.nodeId,
      placeId,
      this.tenantId
    );
    return results;
  }

  /**
   * 既存検索結果(検査箇所)と検索結果を結合させる
   * @param {*} filterList　既存検索結果(検査箇所)
   * @param {*} additionalFilterList　検査結果
   * @returns
   */
  async addInspectResultSet(filterList,additionalFilterList) {
    let placeResultList = [];
    filterList.forEach(place => {
      // 検査箇所からplaceId取得
      const placeId = place.inspectPlace.placeId;
      // 検査結果から、placeIdを含むskを検索
      const inspectResult = additionalFilterList.find(item =>
        item.sk.includes(placeId)
      );

      // placeResultListに追加
      placeResultList.push({
        ...place,
        inspectResult: inspectResult.inspectResultSet
      });
    });
    return placeResultList;
  }
}

module.exports = InspectPlaceListViewModel;
